// The console's loading activity in one place (Ruben, 4 Nov 2026: « add a
// loading state … good practice on state and loading state inside the
// platform »). Every read a person is waiting for (a tab's first load, a new
// period, another home, « Réessayer ») goes through track(), and the thin bar
// at the top of the window shows while at least one is running. Background
// refreshes (Realtime, the 30 s safety net) stay silent: nobody asked for
// them, so they never move the bar.
import { useSyncExternalStore } from 'react';

let pending = 0;
const subs = new Set<() => void>();
const emit = () => subs.forEach((f) => f());

export function track<T>(p: Promise<T>): Promise<T> {
  pending++; emit();
  const done = () => { pending = Math.max(0, pending - 1); emit(); };
  p.then(done, done);
  return p;
}

export const pendingCount = () => pending;

export function useBusy(): boolean {
  return useSyncExternalStore(
    (f) => { subs.add(f); return () => { subs.delete(f); }; },
    () => pending > 0,
  );
}
